/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon';
icon.register({
  'international': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M83.3 103a85 85 0 0 0-15.5-19.5c-2.3-2.5-2.1-4.3-1.3-9.9V73c.6-3.8 1.5-6 14.3-8.1 6.5-1 8.2 1.5 10.6 5.2l.8 1.1a12.6 12.6 0 0 0 6.4 5.3c1.2.5 2.5 1.1 4.4 2.2 4.6 2.5 4.6 5.4 4.6 11.7v.8a27 27 0 0 1-5.1 17.4 59 59 0 0 1-19 11c3.4-6.5.7-14.3 0-16.5h-.2zM64 5.1A58.5 58.5 0 0 1 89.5 11a54.3 54.3 0 0 0-12.9 10.4l-2.4 3.5c-2.5 3.7-3.7 5.4-5.9 5.7a25.1 25.1 0 0 1-4.2 0c-4.3-.3-10-.7-12 4.4-1.1 3.2-1.3 12 2.5 16.5a4 4 0 0 1 .3 3.6 7 7 0 0 1-2 3.2 19 19 0 0 1-3-3 19 19 0 0 0-8.3-6.5l-4-1c-3.7-.7-8-1.6-9-3.8a14.9 14.9 0 0 1-.7-5.8 22 22 0 0 0-1.4-9.2 8.9 8.9 0 0 0-5.6-5A58.7 58.7 0 0 1 64 5.1zM0 64a64 64 0 1 0 128 0A64 64 0 0 0 0 64z"/>'
  }
});